import * as React from "react";
import { connect } from "react-redux";

class EVisitDependent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        const { technicalHelpDeskNumber, technicalHelpDeskHours } = this.props;
        let helpDeskLink = <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>;

        return (
            <div className="container-fluid body-content evisit-dependent-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">Dependent eVisits or Screenings</h1>
                        <p>
                            To complete this screening or eVisit for a dependent, ages 2-17,{' '}
                            you must first be established as their proxy in MyBSWHealth.{' '}
                            To add a proxy dependent, complete <a href="https://www.bswhealth.com/SiteCollectionDocuments/patient-tools/form-proxy-child-mychart-bsw.pdf" target="_blank">this form</a> and send it to <a href="mailto:himadministrator@bswhealth.org">himadministrator@bswhealth.org</a>.{' '}
                            At this time, proxy relationships can only be set up for dependents who have a Baylor Scott & White patient record on file.{' '}
                            Please allow 1 business day for review and processing on business days from 8 AM - 5 PM.{' '}
                        </p>
                        <p>
                            If you are unable to print and scan the form, call the MyBSWHealth technical help desk {technicalHelpDeskHours} at {helpDeskLink}.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:""
    };
};

export default connect(mapStateToProps)(EVisitDependent);